// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d830c7ee","292":"5736a327","369":"3760ddef","453":"c082cd20","732":"f942ebca"}[chunkId] + ".chunk.js";
};